import React from "react";
import Filter from "./Filter";
import Dropdown from "./Dropdown";

const DropdownFilter = ({
  name,
  getTitle,
  search,
  title,
  searchPlaceholder,
  defaultValue,
  values,
  className,
  onFilter
}) => {
  return (
    <Filter {...{ name, title, defaultValue, getTitle, className, onFilter }}>
      <Dropdown {...{ search, searchPlaceholder, values }} />
    </Filter>
  );
};

export default DropdownFilter;
